import { z } from 'zod';
import { patternShape } from './_shared';

export const pattern_created = patternShape.extend({
  source: z.enum(['wizard', 'builder', 'import', 'fork', 'ai_import']),
}).strict();

export const pattern_deleted = z.object({}).strict();

export const pattern_forked = patternShape.extend({
  source: z.literal('fork'),
}).strict();

export const pattern_imported = z.object({
  import_outcome: z.enum(['success', 'hash_mismatch', 'validation_failed', 'network_failed']),
  segment_count: z.number().int().nonnegative().optional(),
  step_count: z.number().int().nonnegative().optional(),
}).strict();
